module.exports = __webpack_public_path__ + "/static/assets/eeaf5c24303dabcce1d37ade582a3f37.png";